import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class Recipient extends ApplicationRecord {
  static jsonapiType = "recipients";

  @Attr() deliverableId: number;

  @Attr() deliverableType: string;

  @Attr() email: string;

  @Attr() status: string;
}

export default Recipient;
